package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Activity
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import io.horion.cv.models.ActivityState
import org.jetbrains.compose.web.css.px

@Composable
fun ActivityAccordionContent(
    onComplete: (String) -> Unit,
    onAddFormationAndClose: (String) -> Unit,
) {
    val cvViewModel = koinGet<CvViewModel>()
    val activitiesFromVM = cvViewModel.cvUiState.data.extracurricularActivities

    LaunchedEffect(Unit) {
        if (activitiesFromVM.isEmpty()) {
            cvViewModel.updateActivity(0, Activity("", "", "", "", "", ""))
            cvViewModel.editingActivityId = "activity-0"
        }
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            },
        verticalArrangement = Arrangement.spacedBy(30.px),
    ) {

        activitiesFromVM.forEachIndexed { index, act ->
            val tempId = "activity-$index"

            val activityState = remember(act) {
                ActivityState(
                    id = tempId,
                    poste = act.name,
                    employeur = act.enterprise,
                    ville = act.city,
                    moisDebut = act.started.split("-").getOrNull(0) ?: "",
                    anneeDebut = act.started.split("-").getOrNull(1) ?: "",
                    moisFin = act.ended.split("-").getOrNull(0) ?: "",
                    anneeFin = act.ended.split("-").getOrNull(1) ?: "",
                    isOngoing = act.ended == "En cours",
                    description = act.description
                )
            }

            GenericFormCard(
                item = activityState,
                isEditing = cvViewModel.editingActivityId == tempId,
                onEdit = { cvViewModel.editingActivityId = tempId },
                onDelete = {
                    cvViewModel.deleteActivity(index)
                    if (cvViewModel.cvUiState.data.extracurricularActivities.isEmpty()) {
                        cvViewModel.updateActivity(0, Activity("", "", "", "", "", ""))
                        cvViewModel.editingActivityId = "activity-0"
                    } else {
                        cvViewModel.editingActivityId = null
                    }
                },
                onComplete = { cvViewModel.editingActivityId = null },
                getSummary = { a ->
                    if (a.poste.isNotBlank() || a.employeur.isNotBlank()) {
                        SummaryData(
                            title = a.poste.ifBlank { "[Poste]" },
                            subtitle = a.employeur.ifBlank { "[Employeur]" }
                        )
                    } else null
                },
                getDefaultText = { "[Activités extra-scolaires]"},
                formContent = { state, onDel, onComp ->
                    ActivityForm(
                        index = index,
                        state = state,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp,

                    )
                }
            )
        }

        AddButton(
            text = "Ajouter une activité extra-scolaire",
            onClick = {
                val nextIndex = activitiesFromVM.size
                cvViewModel.updateActivity(nextIndex, Activity("", "", "", "", "", ""))
                cvViewModel.editingActivityId = "activity-$nextIndex"
            }
        )
    }
}